export { default } from './TouchFeedback';


//////////////////
// WEBPACK FOOTER
// ../~/_rmc-feedback@2.0.0@rmc-feedback/es/index.js
// module id = 1629
// module chunks = 0